import { useTranslations } from "next-intl";
import styles from "./edit-listing-loading.module.css";
import MapViewLoading from "./components/map/map-view-loading";

export default function EditListingLoading() {
  const t = useTranslations("NewListing");
  return (
    <main className={styles.main}>
      <div className={styles.contentWrapper}>
        <h2 className={styles.title}>{t("editListingTitle")}</h2>
        <h3 className={styles.description}>{t("keyFeatures")}</h3>
        <hr className={styles.separator} />
        <div className={`${styles.switcherLoading} ${styles.isLoading}`}></div>
        <div className={`${styles.purposeLoading} ${styles.isLoading}`}></div>
        <div
          className={`${styles.fieldTitleLoading} ${styles.isLoading}`}
          style={{ width: "190px" }}
        ></div>
        <div className={`${styles.inputLoading} ${styles.isLoading}`}></div>
        <div
          className={`${styles.fieldTitleLoading} ${styles.isLoading}`}
        ></div>
        <div className={`${styles.inputLoading} ${styles.isLoading}`}></div>
        <div
          className={`${styles.fieldTitleLoading} ${styles.isLoading}`}
          style={{ width: "250px" }}
        ></div>
        <div
          className={`${styles.fieldDescriptionLoading} ${styles.isLoading}`}
          style={{ width: "180px" }}
        ></div>
        <div className={`${styles.photosLoading} ${styles.isLoading}`}></div>
        <div
          className={`${styles.addPhotosButtonLoading} ${styles.isLoading}`}
        ></div>
        <div className={styles.pillsWrapper}>
          <div className={styles.pillsRow}>
            <div className={styles.pillWrapper}>
              <div
                className={`${styles.fieldTitleLoading} ${styles.isLoading}`}
                style={{ width: "250px" }}
              ></div>
              <div
                className={`${styles.pillLoading} ${styles.isLoading}`}
              ></div>
            </div>
            <div className={styles.pillWrapper}>
              <div
                className={`${styles.fieldTitleLoading} ${styles.isLoading}`}
                style={{ width: "250px" }}
              ></div>
              <div
                className={`${styles.pillLoading} ${styles.isLoading}`}
              ></div>
            </div>
          </div>
          <div className={styles.pillsRow}>
            <div className={styles.pillWrapper}>
              <div
                className={`${styles.fieldTitleLoading} ${styles.isLoading}`}
                style={{ width: "250px" }}
              ></div>
              <div
                className={`${styles.pillLoading} ${styles.isLoading}`}
              ></div>
            </div>
            <div className={styles.pillWrapper}>
              <div
                className={`${styles.fieldTitleLoading} ${styles.isLoading}`}
                style={{ width: "250px" }}
              ></div>
              <div
                className={`${styles.pillLoading} ${styles.isLoading}`}
              ></div>
            </div>
          </div>
        </div>
        <div
          className={`${styles.fieldTitleLoading} ${styles.isLoading}`}
          style={{ width: "120px" }}
        ></div>
        <div className={`${styles.inputLoading} ${styles.isLoading}`}></div>
        <div
          className={`${styles.fieldTitleLoading} ${styles.isLoading}`}
          style={{ width: "220px" }}
        ></div>
        <div className={`${styles.inputLoading} ${styles.isLoading}`}></div>
        <div
          className={`${styles.fieldTitleLoading} ${styles.isLoading}`}
          style={{ width: "180px" }}
        ></div>
        <div className={`${styles.inputLoading} ${styles.isLoading}`}></div>
        <div
          className={`${styles.fieldTitleLoading} ${styles.isLoading}`}
          style={{ width: "240px" }}
        ></div>
        <div className={`${styles.inputLoading} ${styles.isLoading}`}></div>
        <div
          className={`${styles.fieldTitleLoading} ${styles.isLoading}`}
          style={{ width: "130px" }}
        ></div>
        <div className={`${styles.inputLoading} ${styles.isLoading}`}></div>
        <div
          className={`${styles.fieldTitleLoading} ${styles.isLoading}`}
        ></div>
        <div className={`${styles.inputLoading} ${styles.isLoading}`}></div>
        <div
          className={`${styles.fieldTitleLoading} ${styles.isLoading}`}
          style={{ width: "220px" }}
        ></div>
        <div className={`${styles.inputLoading} ${styles.isLoading}`}></div>
        <MapViewLoading />
        <div
          className={`${styles.fieldTitleLoading} ${styles.isLoading}`}
          style={{ width: "220px" }}
        ></div>
        <div
          className={`${styles.descriptionLoading} ${styles.isLoading}`}
        ></div>
        <div
          className={`${styles.saveButtonLoading} ${styles.isLoading}`}
        ></div>
      </div>
    </main>
  );
}
